<template>
    <b-container fluid class="div-background">
        <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
        <div class="Info_Area">
            <b-row align-h="center" >
                <b-col md="10" >
                    <b-row>
                        <b-col>
                            <!-- <b-col xl="3" md="6" sm="12"> -->
                            <b-card style="border:0;">
                                <b-row style="margin-bottom: 1rem;">
                                    <b-col md="3"  class="crop_md crop_title">
                                        <div>
                                            <b-card class="card_md4 orange">
                                                已訂閱作物
                                            </b-card>
                                            <div>
                                                <span class="warningText">※訂閱作物的品項以作物統稱分類，並對應相應的農情作物與市場作物名稱。</span>
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col md="7" class="crop_md cropcard">
                                        <!-- <b-row no-gutters>
                                            <b-col v-for="(mycrop,index2) in myCroplist" :key="index2" md="1.5">
                                                <b-card class="mycrop">
                                                    {{ mycrop }}
                                                </b-card>
                                            </b-col>
                                        </b-row> -->
                                        <b-row>
                                            <b-col md="11">
                                                <b-row>
                                                    <table cellpadding="10" v-if="myCroplist.length > 0">
                                                        <tr>
                                                            <td>作物統稱:</td>
                                                            <td v-for="(tmycrop,tindex) in myCroplist" :key="tindex">
                                                                {{ tmycrop.V_COMMON }}
                                                            </td>
                                                        </tr>
                                                        <tr v-show="tableToggle">
                                                            <td>農情作物名稱:</td>
                                                            <td v-for="(vcrop,vindex) in myCroplist" :key="vindex">
                                                                {{vcrop.C_NAME}}
                                                            </td>
                                                        </tr>
                                                        <tr v-show="tableToggle">
                                                            <td>市場作物名稱:</td>
                                                            <td v-for="(vcrop,vindex) in myCroplist" :key="vindex">
                                                                <div v-for="(product,pindex) in vcrop.Product" :key="pindex">
                                                                    {{product}}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </b-row>
                                            </b-col>
                                            <b-col cols="1" v-if="myCroplist.length > 0"  align-self="center" >
                                                <button style="border: 0;background-color: transparent;" @click="tableToggle = !tableToggle">
                                                    <span  v-if="!tableToggle" class="icon-circle-down"/>
                                                    <!-- <svg v-if="!tableToggle" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="size-6">
                                                        <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5"></path>
                                                    </svg> -->
                                                    <span  v-else class="icon-circle-up"/>
                                                    <!-- <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="size-6">
                                                        <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75 12 8.25l7.5 7.5"></path>
                                                    </svg> -->
                                                </button>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                    <b-col class="crop_md">
                                        <b-button
                                            @click="$router.push('/subscription')"
                                            block
                                            class="btn btn-success"
                                            >修改訂閱作物</b-button
                                        >
                                    </b-col>
                                </b-row>
                                <b-row style="margin-bottom: 1rem;">
                                    <b-col md="3" style="display: flex; align-items:center;justify-content: center;">
                                        <div style="width: 100%;">
                                            <b-card class="card_md4 gray">
                                                農作物氣象預警
                                            </b-card>
                                            <div>
                                                <span class="warningText">※農作物氣象預警，以農情作物名稱作為依據。</span>
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col>
                                        <b-card-text>
                                            <b-row style="text-align: center" v-if="ifwarningloading">
                                                <b-col
                                                    ><b-spinner variant="success" label="Spinning"></b-spinner
                                                ></b-col>
                                            </b-row>
                                            <b-row v-else align-h="start" no-gutters>
                                            <template v-for="(item, index) in warningarray">
                                                <b-col
                                                    class="warning_col"
                                                    md="1.5"
                                                    sm="1.5"
                                                    v-if="item.warning == 0"
                                                    :key="index"
                                                    >
                                                <b-row>
                                                    <b-col>
                                                        <b-button
                                                            block
                                                            class="warning-btn"
                                                            @click="
                                                            showtheCrops(item)
                                                            "
                                                            ><span class="icon icon-rain" /> 霪雨警戒
                                                            <span class="icon-circle-down"
                                                        /></b-button>
                                                    </b-col>
                                                </b-row>
                                                </b-col>
                                                <b-col
                                                    class="warning_col"
                                                    v-else-if="item.warning == 1"
                                                    :key="index"
                                                    md="1.5"
                                                    sm="1.5"
                                                >
                                                <b-row>
                                                    <b-col>
                                                        <b-button
                                                            block
                                                            class="warning-btn"
                                                            @click="showtheCrops(item)"
                                                            ><span class="icon icon-sunny" /> 高溫警戒
                                                            <span class="icon-circle-down"
                                                        /></b-button>
                                                    </b-col>
                                                </b-row>
                                                </b-col>
                                                <b-col
                                                    class="warning_col"
                                                    v-else-if="item.warning == 2"
                                                    :key="index"
                                                    md="1.5"
                                                    sm="1.5"
                                                >
                                                <b-row>
                                                    <b-col>
                                                        <b-button
                                                            block
                                                            class="warning-btn"
                                                            @click="
                                                            showtheCrops(item)
                                                            "
                                                            ><span class="icon icon-foehn" /> 焚風警戒
                                                            <span class="icon-circle-down"
                                                        /></b-button>
                                                    </b-col>
                                                </b-row>
                                                </b-col>
                                                <b-col
                                                    class="warning_col"
                                                    v-else-if="item.warning == 3"
                                                    :key="index"
                                                    md="1.5"
                                                    sm="1.5"
                                                    >
                                                    <b-row>
                                                        <b-col>
                                                            <b-button
                                                            block
                                                            class="warning-btn"
                                                            @click="
                                                            showtheCrops(item)
                                                            "
                                                            ><span class="icon icon-rainy" /> {{checkMomth()}}警戒
                                                            <span class="icon-circle-down"
                                                        /></b-button>
                                                        </b-col>
                                                        <!-- <b-col>
                                                            <b-row class="warning_card">
                                                                <b-col md="1.5" v-for="(crop, index1) in item.crop" :key="index1">
                                                                    <b-card class="crop_card">
                                                                        {{ crop}}
                                                                    </b-card>
                                                                </b-col>
                                                            </b-row>
                                                        </b-col> -->
                                                    </b-row>
                                                </b-col>
                                                <b-col
                                                    class="warning_col"
                                                    v-else-if="item.warning == 4"
                                                    :key="index"
                                                    md="1.5"
                                                    sm="1.5"
                                                    >
                                                    <b-row>
                                                        <b-col>
                                                            <b-button
                                                            block
                                                            class="warning-btn"
                                                            @click="
                                                            showtheCrops(item)
                                                            "
                                                            ><span class="icon icon-typhoon" /> 颱風警戒
                                                            <span class="icon-circle-down"
                                                            /></b-button>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                                <b-col
                                                    class="warning_col"
                                                    v-else-if="item.warning == 11"
                                                    :key="index"
                                                    md="1.5"
                                                    sm="1.5"
                                                    >
                                                    <b-row>
                                                        <b-col>
                                                            <b-button
                                                                block
                                                                class="warning-btn"
                                                                @click="
                                                                showtheCrops(item)
                                                                "
                                                                ><span class="icon icon-typhoon" /> 寒害警戒
                                                                <span class="icon-circle-down"
                                                            /></b-button>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                                <b-col
                                                    class="warning_col"
                                                    v-else-if="item.warning == 5"
                                                    :key="index"
                                                    md="1.5"
                                                    sm="1.5"
                                                    >
                                                    <b-row> <!--showtheCrops(item)-->
                                                        <b-col>
                                                            <b-button
                                                                block
                                                                class="notice-btn"
                                                                @click="showtheCrops(item)"
                                                                ><span class="icon icon-high_tprt" /> 注意回溫
                                                                <span class="icon-circle-down"/>
                                                            </b-button>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                                <b-col
                                                    class="warning_col"
                                                    v-else-if="item.warning == 6"
                                                    :key="index"
                                                    md="1.5"
                                                    sm="1.5"
                                                    >
                                                    <b-row>
                                                        <b-col>
                                                            <b-button
                                                                block
                                                                class="notice-btn"
                                                                @click="
                                                                showtheCrops(item)
                                                                "
                                                                ><span class="icon icon-lower_tprt" /> 注意降溫
                                                                <span class="icon-circle-down"
                                                            /></b-button>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                                <b-col
                                                    class="warning_col"
                                                    v-else-if="item.warning == 7"
                                                    :key="index"
                                                    md="1.5"
                                                    sm="1.5"
                                                    >
                                                    <b-row>
                                                        <b-col>
                                                            <b-button
                                                                block
                                                                class="notice-btn"
                                                                @click="
                                                                    showtheCrops(item)
                                                                "
                                                                ><span class="icon icon-rain" /> 注意霪雨
                                                                <span class="icon-circle-down"
                                                            /></b-button>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                                <b-col
                                                    class="warning_col"
                                                    v-else-if="item.warning == 8"
                                                    :key="index"
                                                    md="1.5"
                                                    sm="1.5"
                                                    >
                                                    <b-row>
                                                        <b-col>
                                                            <b-button
                                                                block
                                                                class="notice-btn"
                                                                @click="
                                                                showtheCrops(item)
                                                                "
                                                                ><span class="icon icon-rain" /> 注意梅雨
                                                                <span class="icon-circle-down"
                                                            /></b-button>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                                <b-col
                                                    class="warning_col"
                                                    v-else-if="item.warning == 9"
                                                    :key="index"
                                                    md="1.5"
                                                    sm="1.5"
                                                    >
                                                    <b-row>
                                                        <b-col>
                                                            <b-button
                                                                block
                                                                class="notice-btn"
                                                                @click="
                                                                showtheCrops(item)
                                                                "
                                                                ><span class="icon icon-sunny" /> 注意高溫
                                                                <span class="icon-circle-down"
                                                            /></b-button>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                                <b-col
                                                    class="warning_col"
                                                    v-else-if="item.warning == 10"
                                                    :key="index"
                                                    md="1.5"
                                                    sm="1.5"
                                                    >
                                                    <b-row>
                                                        <b-col>
                                                            <b-button
                                                                block
                                                                class="notice-btn"
                                                                @click="
                                                                showtheCrops(item)
                                                                "
                                                                ><span class="icon icon-chilling" /> 注意寒害
                                                                <span class="icon-circle-down"
                                                            /></b-button>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                            </template>
                                            </b-row>
                                        </b-card-text>
                                    </b-col>
                                </b-row>
                                <b-row style="margin-bottom: 0.5rem;">
                                    <b-col md="3">
                                    </b-col>
                                    <b-col md="9" v-if="showCrop">
                                        <b-row no-gutters class="warning_crop">
                                            <b-col md="12" class="warning_crop_col">
                                                <b-row no-gutters>
                                                    <b-col md="11">
                                                        <h3>可能影響-{{ showCropTitle }}</h3>
                                                    </b-col>
                                                    <b-col md="1" style="display: flex; justify-content: end;">
                                                        <b-button class="close-button">
                                                        <b-icon
                                                            icon="x"
                                                            scale="1.2"
                                                            style="color: #ffffff; padding:0;"
                                                            @click="showCrop=!showCrop"
                                                        ></b-icon>
                                                        </b-button>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="12" class="warning_crop_col crop_btn" >
                                                <b-row no-gutters>
                                                    <b-col md="2" style="margin:0.5rem 0.5rem 0.5rem 0 ;" v-for="(item,index) in cropbtn" :key="index">
                                                        <button  :class="{'btn_active':flagN === item.crop}" @click="changeEffect(item)">{{item.crop}}</button>
                                                        <!-- <b-button :active="active" variant="outline-warning" class="crop_btn" @click="changeEffect(item)">{{item.crop}}</b-button>                                                         -->
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="12" class="warning_crop_col">
                                                <div class="crop_effect"> 
                                                    <span>{{EFFECT}}</span>
                                                </div>
                                            </b-col>
                                            <b-col md="12" class="warning_crop_col">
                                                <b-button variant="info" style="width: 100%;" @click="$router.push({ name: 'GIS', query: { id: Note_CropId } })">詳細資訊</b-button>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                                <!-- <b-row>
                                    <b-col md="12"  class="crop_md table_title">
                                        <b-card class="card_md4 gray">
                                            農業氣象預警
                                        </b-card>
                                    </b-col>
                                </b-row> -->
                                <b-row>
                                    <b-col md="3" style="display: flex; align-items:center;justify-content: center;">
                                        <div style="width: 100%;">
                                            <b-card class="card_md4 blue">
                                                農作物交易價量分析
                                            </b-card>
                                            
                                        </div>
                                    </b-col>
                                </b-row>
                                <div>
                                    <span class="warningText">※農產品交易價量分析，以市場作物名稱作為依據；市場作物名稱的選項會根據查詢時間的不同，僅顯示該時間區間內有交易的市場作物品項。</span>
                                </div>
                                <b-row >
                                    <b-col md="12" class="crop_md">
                                        <div style="width: 100%;">
                                            <b-card no-body>
                                                <b-tabs v-model="mainpage.tabnum" card>
                                                <b-tab
                                                    v-show="mainpage.show"
                                                    v-for="(item, index) in mainpage.tabobject"
                                                    :key="index"
                                                    :title="item.title"
                                                >
                                                    <!-- <keep-alive> -->
                                                    <component v-bind:is="item.component" :data="item.data"></component>
                                                    <!-- </keep-alive> -->
                                                </b-tab>
                                                </b-tabs>
                                            </b-card>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-col>
                    </b-row>
                    
                </b-col>            
            </b-row>
        </div>
    </b-container>
</template>
<script>
//import Bulletin from '../components/Bulletin.vue'
import MyCropmarketalaysis from '../components/MyCropmarketalaysis.vue'
import MyCropmarketalaysisForMonth from '../components/MyCropmarketalaysisForMonth.vue'
import MyCropmarketalaysisForYear from '../components/MyCropmarketalaysisForYear.vue'
import MyCropfiveyearstrade from '../components/MyCropfiveyearstrade.vue'
export default{
data(){
    return {
        tab:null,
        myToggle:true,
        active:true,
        showCrop:false,
        EFFECT:null,
        flagN:null,
        Note_CropId:null,
        showCropTitle:null,
        cropbtn:[],
        breadcrumbItems: [
            {
            text: "首頁",
            href: "#",
            },
            {
            text: "我的專區",
            active: true,
            },
        ],
        myCroplist:[],
        tableToggle:false,
        ifwarningloading: true,
        warningarray: [],
        warningdispalylist: [
            {
            key: "霪雨",
            value: 3,
            },
            {
            key: "高溫",
            value: 1,
            },
            {
            key: "焚風",
            value: 2,
            },
            {
            key: "降水",
            value: 3,
            },
            {
            key: "颱風",
            value: 4,
            },
            {
            key: "寒害",
            value: 11,
            },
            {
            key: "注意回溫",
            value: 5,
            },
            {
            key: "注意降溫",
            value: 6,
            },
            {
            key: "注意霪雨",
            value: 7,
            },
            {
            key: "注意梅雨",
            value: 8,
            },
            {
            key: "注意高溫",
            value: 9,
            },
            {
            key: "注意寒害",
            value: 10,
            },
        ],
        warninglist: 
            {
            0: "霪雨",
            1: "高溫",
            2: "焚風",
            3: "降水",
            4: "颱風",
            5: "注意回溫",
            6: "注意降溫",
            7: "注意霪雨",
            8: "注意梅雨",
            9: "注意高溫",
            10: "注意寒害",
            11: "寒害",
            },
        mainpage: {
        tabnum: 0,
        show: true,
        tabobject: [
            {
                title: "市場交易價量分析(日)",
                //component: Bulletin,
                component: MyCropmarketalaysis,
                data: { name: "市場交易價量分析(日)" },
            },
            {
                title: "市場交易價量分析(月)",
                //component: Bulletin,
                component: MyCropmarketalaysisForMonth,
                data: { name: "市場交易價量分析(月)" },
            },
            {
                title: "市場交易價量分析(年)",
                //component: Bulletin,
                component: MyCropmarketalaysisForYear,
                data: { name: "市場交易價量分析(年)" },
            },
            {
                title: "近五年交易量變化",
                //component: Bulletin,
                component: MyCropfiveyearstrade,
                data: { name: "近五年交易量變化" },
            },
        ],
        tabslist: [],
        },
        apiCropSubscribeList: (data) =>
            this.userRequest.post("API/Default/CropSubscribeList", data),
        apiGetMyScourge: (data) =>
            this.userRequest.post("API/Default/getMyScourge", data),
        
    }
},
mounted(){
    this.checkLogin();
},
methods:{
    checkLogin() {
        let TokenID = sessionStorage.getItem("TokenID");
        if (TokenID) {
            this.init();
        } else {
        alert("未有權限檢視此頁面，請登入帳號");
        this.$router.push({ path: "/login" });
        }
    },
    init(){
        this.FunctionToken(this.getMyScourge,{});
        this.FunctionToken(this.getCropSubscribeList,{});
        
    },
    getMyScourge(data){
        this.apiGetMyScourge(data)
            .then((res) =>{
                let data = JSON.parse(res.data);
                if (data.Status) {
                let jsonData = JSON.parse(data.Data);
                //console.log("jsonData",jsonData)
                
                this.warningarray = [];
                jsonData.forEach((element) => {
                    let sublist = this.warningdispalylist.filter(
                        (it) => it.key == element.DISASTER
                    );
                    
                    let subindex = sublist.length ? sublist[0].value : -1;
                    
                    let index = this.warningarray.findIndex(it => it.warning == subindex);

                    if (index == -1) {
                        let crop = jsonData.filter((it) => it.DISASTER == element.DISASTER);
                        let croplist=[];
                        crop.forEach((ele)=>{
                            if(croplist.findIndex(it => it.crop==ele.C_NAME) ==-1){
                                let cropobj = {
                                    crop: ele.C_NAME,
                                    EFFECT :ele.EFFECT,
                                    Note_CropId :ele.Note+"_"+ele.ANA_C_ID
                                }
                                croplist.push(cropobj);
                            }
                        })
                        //console.log("croplist",croplist)
                        let obj ={
                            warning:subindex,
                            crop: croplist
                        }
                        this.warningarray.push(obj);
                        //console.log("this.warningarray",this.warningarray)
                    }
                });
                //console.log(this.warningarray);
                this.ifwarningloading = false;
            }
            })
    },
    getCropSubscribeList(data) {
        this.apiCropSubscribeList(data)
        .then((res) =>{
            let data = JSON.parse(res.data);
            if(data.Status){
                let jsondata = JSON.parse(data.Data);
                console.log("getCropSubscribeList",jsondata);
                jsondata.forEach((item) =>{
                    let obj ={
                        C_NAME: item.C_NAME,
                        V_COMMON: item.V_COMMON,
                        Product: item.products.split('、')
                    }
                    this.myCroplist.push(obj);
                })
                //console.log("myCroplist",this.myCroplist);
            }
        })
    },
    showtheCrops(item){
        //console.log("showtheCrops",item);
        this.cropbtn =[];
        //this.cropbtn = item.crop;
        //console.log("this.cropbtn ",this.cropbtn);
        for(let i=0; i< item.crop.length ;i++){
            let state =false;
            if(i ==0 ) state=true;
            let obj={
                crop: item.crop[i].crop,
                EFFECT:item.crop[i].EFFECT,
                Note_CropId:item.crop[i].Note_CropId,
                state:state
            }
            this.cropbtn.push(obj);
        }
        //console.log("this.cropbtn",this.cropbtn)
        this.showCropTitle = item.warning !=3 ? this.warninglist[item.warning] : this.checkMomth();
        this.showCrop =true;
        this.EFFECT = this.cropbtn[0].EFFECT;
        this.flagN = this.cropbtn[0].crop;
        this.Note_CropId=this.cropbtn[0].Note_CropId
    },
    changeEffect(item){
    //console.log("changeEffect item",item)
        this.EFFECT=item.EFFECT;
        this.flagN =item.crop;
        this.Note_CropId=item.Note_CropId;
    },
    checkMomth() {
        let name = "霪雨";
        var d = new Date();
        var nowMonth = d.getMonth() + 1;
        if (nowMonth == 5 || nowMonth == 6) {
            name = "梅雨";
        }
        return name;
    },
}
}
</script>
<style lang="scss" scoped>
.crop_md{
    display: flex;
    align-items:center;
    margin-bottom: 1rem;

    &.crop_title{
        justify-content: center;
    }
    &.table_title{
        text-align: center;
    }
    &.md9{
        width: 100%;
    }
}
.card-body{
    padding: 0.5rem;
}
.card_md4{
    padding: 0.1rem;
    font-size: 22px;
    font-weight: 800;
    color: #ffffff;
    border-radius: 10px;
    width: 100%;
    &.orange {
        background-color: #f0b209;
    }
    &.gray{
        background-color: #4F4F4F;
    }
    &.blue{
        background-color: #265ec0;
    }
}
.crop_card{
    background-color: #e3dfdf;
    border: 0;
    margin-right: 0.1rem;
    font-weight: 700;
}
.mycrop{
    background-color: #eeeef0;
    border: 0;
    margin-right: 0.2rem;
    font-weight: 700;
}
.warning_col{
    margin: 0.1rem;
}
.warning_card{
    margin-left: 0.01rem;
}
.warning-btn {
    /* font-size: smaller; */
    background: #ff614c;
    border-color: #ff614c;
    color: white;
    height: 80px;
}
.warning-btn:hover {
    background: #db3c30 !important;
    border-color: #db3c30 !important;
}
.notice-btn {
/* font-size: smaller; */
    background: #f5b847;
    border-color: #f5b847;
    color: white;
    height: 80px;
}
.notice-btn:hover {
    background: #d98e3f !important;
    border-color: #d98e3f !important;
}

.warning_crop{
    border-color:#282950;
    border-radius: 10px;
    background-color: #0c0c0d;
    padding: 1rem 1rem 0 1rem;
    color: #ffffff;
}
.warning_crop_col{
    margin-bottom: 0.5rem;
    width: 100%;
}
.crop_btn{
    button{
        width: 100%;
        background-color: #e6781e;
        border: 1px solid;
        border-color: #e6781e;
        color: white;
        font-weight: bolder;
        min-height: 30px;
        border-radius: 5px;
        font-size: large;
    }
    .btn_active{
        box-shadow: rgba(255, 255, 255, 0.16) 0px 1px 4px, rgb(255, 255, 255) 0px 0px 0px 3px;
    }
    
}

.crop_effect{
    padding: 1rem;
    border-color:#ffffff;
    border:1px solid;
    border-radius: 5px;
    background-color: #1e1f44;
    min-height: 80px;
}
.warningText{
    color: blue;
}
</style>